// @ts-nocheck
import * as Types from '../../../@types/apiql.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TGetHeaderDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TGetHeaderDataQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id: string, entitlements: { __typename?: 'UserEntitlementsConnection', edges?: Array<{ __typename?: 'UserEntitlementsEdge', node: { __typename: 'EntitlementSubscribeType', id?: string | null } | { __typename: 'EntitlementBuyType', id?: string | null } | { __typename: 'EntitlementDefaultType', id?: string | null } | { __typename: 'EntitlementPassType', id?: string | null } | { __typename: 'EntitlementPurchaseType', id?: string | null } | { __typename: 'EntitlementRentType', id?: string | null } | { __typename: 'EntitlementThirdPartyType', id?: string | null } } | null> | null } } };


export const GetHeaderDataDocument = gql`
    query GetHeaderData {
  viewer {
    id: magineId
    entitlements {
      edges {
        node {
          __typename
          id: offerId
        }
      }
    }
  }
}
    `;

/**
 * __useGetHeaderDataQuery__
 *
 * To run a query within a React component, call `useGetHeaderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderDataQuery(baseOptions?: Apollo.QueryHookOptions<TGetHeaderDataQuery, TGetHeaderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TGetHeaderDataQuery, TGetHeaderDataQueryVariables>(GetHeaderDataDocument, options);
      }
export function useGetHeaderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetHeaderDataQuery, TGetHeaderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TGetHeaderDataQuery, TGetHeaderDataQueryVariables>(GetHeaderDataDocument, options);
        }
export type GetHeaderDataQueryHookResult = ReturnType<typeof useGetHeaderDataQuery>;
export type GetHeaderDataLazyQueryHookResult = ReturnType<typeof useGetHeaderDataLazyQuery>;
export type GetHeaderDataQueryResult = Apollo.QueryResult<TGetHeaderDataQuery, TGetHeaderDataQueryVariables>;